module.exports = __webpack_public_path__ + "topic.27934cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/xmas/topic.png
// module id = 915
// module chunks = 0